import { useMemo } from "react";
import "./noEvents.sass";

export default function NoEvents({ type }) {

  const heightStyle = useMemo(() => {
    return { minHeight: `${Number(type || 130)}px` };
  }, [type]); // Solo se recalcula si cambia `type`

  return (
    <div className="no-events-alert" style={heightStyle}>
      <p> eventos por confirmar </p>
    </div>
  );
}